package `fun`.adaptive.ui.builtin

import `fun`.adaptive.resource.graphics.Graphics
import `fun`.adaptive.resource.graphics.GraphicsResource
import `fun`.adaptive.resource.graphics.GraphicsResourceSet

private object commonMainGraphics0 {

    val account_box by lazy { init_account_box() }

    val arrow_drop_up by lazy { init_arrow_drop_up() }

    val empty by lazy { init_empty() }

    val zoom_out_map by lazy { init_zoom_out_map() }

    val arrow_left by lazy { init_arrow_left() }

    val arrows_input by lazy { init_arrows_input() }

    val settings by lazy { init_settings() }

    val menu_book by lazy { init_menu_book() }

    val collapse_all by lazy { init_collapse_all() }

    val chevron_right by lazy { init_chevron_right() }

    val chevron_left by lazy { init_chevron_left() }

    val account_circle by lazy { init_account_circle() }

    val arrow_right by lazy { init_arrow_right() }

    val check by lazy { init_check() }

    val expand_all by lazy { init_expand_all() }

    val add by lazy { init_add() }

    val close by lazy { init_close() }

    val arrow_drop_down by lazy { init_arrow_drop_down() }

    val content_copy by lazy { init_content_copy() }

    val power_settings_new by lazy { init_power_settings_new() }

    val unfold_more by lazy { init_unfold_more() }

    val remove by lazy { init_remove() }

    val unfold_less by lazy { init_unfold_less() }

    val more_vert by lazy { init_more_vert() }

    val menu by lazy { init_menu() }

    val folder by lazy { init_folder() }

    val eco by lazy { init_eco() }

}

val Graphics.account_box
    get() = commonMainGraphics0.account_box

private fun init_account_box() =
    GraphicsResourceSet(
        name = "account_box",
        GraphicsResource("/fun.adaptive.ui.builtin/graphics/account_box.svg", setOf())
    )

val Graphics.arrow_drop_up
    get() = commonMainGraphics0.arrow_drop_up

private fun init_arrow_drop_up() =
    GraphicsResourceSet(
        name = "arrow_drop_up",
        GraphicsResource("/fun.adaptive.ui.builtin/graphics/arrow_drop_up.svg", setOf())
    )

val Graphics.empty
    get() = commonMainGraphics0.empty

private fun init_empty() =
    GraphicsResourceSet(
        name = "empty",
        GraphicsResource("/fun.adaptive.ui.builtin/graphics/empty.svg", setOf())
    )

val Graphics.zoom_out_map
    get() = commonMainGraphics0.zoom_out_map

private fun init_zoom_out_map() =
    GraphicsResourceSet(
        name = "zoom_out_map",
        GraphicsResource("/fun.adaptive.ui.builtin/graphics/zoom_out_map.svg", setOf())
    )

val Graphics.arrow_left
    get() = commonMainGraphics0.arrow_left

private fun init_arrow_left() =
    GraphicsResourceSet(
        name = "arrow_left",
        GraphicsResource("/fun.adaptive.ui.builtin/graphics/arrow_left.svg", setOf())
    )

val Graphics.arrows_input
    get() = commonMainGraphics0.arrows_input

private fun init_arrows_input() =
    GraphicsResourceSet(
        name = "arrows_input",
        GraphicsResource("/fun.adaptive.ui.builtin/graphics/arrows_input.svg", setOf())
    )

val Graphics.settings
    get() = commonMainGraphics0.settings

private fun init_settings() =
    GraphicsResourceSet(
        name = "settings",
        GraphicsResource("/fun.adaptive.ui.builtin/graphics/settings.svg", setOf())
    )

val Graphics.menu_book
    get() = commonMainGraphics0.menu_book

private fun init_menu_book() =
    GraphicsResourceSet(
        name = "menu_book",
        GraphicsResource("/fun.adaptive.ui.builtin/graphics/menu_book.svg", setOf())
    )

val Graphics.collapse_all
    get() = commonMainGraphics0.collapse_all

private fun init_collapse_all() =
    GraphicsResourceSet(
        name = "collapse_all",
        GraphicsResource("/fun.adaptive.ui.builtin/graphics/collapse_all.svg", setOf())
    )

val Graphics.chevron_right
    get() = commonMainGraphics0.chevron_right

private fun init_chevron_right() =
    GraphicsResourceSet(
        name = "chevron_right",
        GraphicsResource("/fun.adaptive.ui.builtin/graphics/chevron_right.svg", setOf())
    )

val Graphics.chevron_left
    get() = commonMainGraphics0.chevron_left

private fun init_chevron_left() =
    GraphicsResourceSet(
        name = "chevron_left",
        GraphicsResource("/fun.adaptive.ui.builtin/graphics/chevron_left.svg", setOf())
    )

val Graphics.account_circle
    get() = commonMainGraphics0.account_circle

private fun init_account_circle() =
    GraphicsResourceSet(
        name = "account_circle",
        GraphicsResource("/fun.adaptive.ui.builtin/graphics/account_circle.svg", setOf())
    )

val Graphics.arrow_right
    get() = commonMainGraphics0.arrow_right

private fun init_arrow_right() =
    GraphicsResourceSet(
        name = "arrow_right",
        GraphicsResource("/fun.adaptive.ui.builtin/graphics/arrow_right.svg", setOf())
    )

val Graphics.check
    get() = commonMainGraphics0.check

private fun init_check() =
    GraphicsResourceSet(
        name = "check",
        GraphicsResource("/fun.adaptive.ui.builtin/graphics/check.svg", setOf())
    )

val Graphics.expand_all
    get() = commonMainGraphics0.expand_all

private fun init_expand_all() =
    GraphicsResourceSet(
        name = "expand_all",
        GraphicsResource("/fun.adaptive.ui.builtin/graphics/expand_all.svg", setOf())
    )

val Graphics.add
    get() = commonMainGraphics0.add

private fun init_add() =
    GraphicsResourceSet(
        name = "add",
        GraphicsResource("/fun.adaptive.ui.builtin/graphics/add.svg", setOf())
    )

val Graphics.close
    get() = commonMainGraphics0.close

private fun init_close() =
    GraphicsResourceSet(
        name = "close",
        GraphicsResource("/fun.adaptive.ui.builtin/graphics/close.svg", setOf())
    )

val Graphics.arrow_drop_down
    get() = commonMainGraphics0.arrow_drop_down

private fun init_arrow_drop_down() =
    GraphicsResourceSet(
        name = "arrow_drop_down",
        GraphicsResource("/fun.adaptive.ui.builtin/graphics/arrow_drop_down.svg", setOf())
    )

val Graphics.content_copy
    get() = commonMainGraphics0.content_copy

private fun init_content_copy() =
    GraphicsResourceSet(
        name = "content_copy",
        GraphicsResource("/fun.adaptive.ui.builtin/graphics/content_copy.svg", setOf())
    )

val Graphics.power_settings_new
    get() = commonMainGraphics0.power_settings_new

private fun init_power_settings_new() =
    GraphicsResourceSet(
        name = "power_settings_new",
        GraphicsResource("/fun.adaptive.ui.builtin/graphics/power_settings_new.svg", setOf())
    )

val Graphics.unfold_more
    get() = commonMainGraphics0.unfold_more

private fun init_unfold_more() =
    GraphicsResourceSet(
        name = "unfold_more",
        GraphicsResource("/fun.adaptive.ui.builtin/graphics/unfold_more.svg", setOf())
    )

val Graphics.remove
    get() = commonMainGraphics0.remove

private fun init_remove() =
    GraphicsResourceSet(
        name = "remove",
        GraphicsResource("/fun.adaptive.ui.builtin/graphics/remove.svg", setOf())
    )

val Graphics.unfold_less
    get() = commonMainGraphics0.unfold_less

private fun init_unfold_less() =
    GraphicsResourceSet(
        name = "unfold_less",
        GraphicsResource("/fun.adaptive.ui.builtin/graphics/unfold_less.svg", setOf())
    )

val Graphics.more_vert
    get() = commonMainGraphics0.more_vert

private fun init_more_vert() =
    GraphicsResourceSet(
        name = "more_vert",
        GraphicsResource("/fun.adaptive.ui.builtin/graphics/more_vert.svg", setOf())
    )

val Graphics.menu
    get() = commonMainGraphics0.menu

private fun init_menu() =
    GraphicsResourceSet(
        name = "menu",
        GraphicsResource("/fun.adaptive.ui.builtin/graphics/menu.svg", setOf())
    )

val Graphics.folder
    get() = commonMainGraphics0.folder

private fun init_folder() =
    GraphicsResourceSet(
        name = "folder",
        GraphicsResource("/fun.adaptive.ui.builtin/graphics/folder.svg", setOf())
    )

val Graphics.eco
    get() = commonMainGraphics0.eco

private fun init_eco() =
    GraphicsResourceSet(
        name = "eco",
        GraphicsResource("/fun.adaptive.ui.builtin/graphics/eco.svg", setOf())
    )